var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Panel',{attrs:{"contentPaddingTop":12}},[_c('search',{on:{"onSubmit":_vm.onSubmit}}),_c('tab',{ref:"tableRef",attrs:{"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }